// /Users/jeremy/development/nwre_softval/src/entities/tsoTests/testsFingrid/csvGeneration/hooks/useDateSubForm.ts
import { useMemo } from "react";
import { FieldValues } from "react-hook-form";

export default function useDateSubForm(formData: FieldValues, index: number) {
  const now = useMemo(() => new Date(), []);
  const startDatetime = formData && formData.tests_config && formData.tests_config[index]?.start_datetime;
  const minDate = startDatetime ? new Date(startDatetime) : now;
  const disabled = formData && formData.tests_config && !formData.tests_config[index]?.selected;

  return { minDate, disabled };
}
